module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("“I’ll tell ya what, Preach, that place is going to take a little more than a hammer and nails and a few more boards to fix it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam joined Noah Benningfield at the edge of the property and stared up at the house. For years, the people of Madison had just called this house the old Frampton place.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Generally, people avoided it. Unless you were a kid … then you might come out here on a dare. Or at least lie and pretend you had.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Plenty had lied, because they all knew if Judge Max had caught you hanging around this place he "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("would")]), _vm._v(" call the cops, he "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("would")]), _vm._v(" press charges and your parents would "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" be able to talk him out of it. Judge Max wasn’t a bad guy, but he had a pretty straightforward sense of right and wrong. The "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No Trespassing")]), _vm._v(" signs were clear enough in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But then he’d managed to sell the house.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It wasn’t much of a house now, though.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam rubbed his jaw, careful to avoid the burns along the right side of his face. They were healing, as were the ones on the outer part of his right arm. He’d received them when he tackled the boy who’d set the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There was still a huge, gaping hole in the side of the house. Police tape surrounded the property. It had only been ten days since the explosion that could have killed Noah and his new fiancée.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Adam thought about it for too long, he just might get sick. Easier to joke about it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t know.” Noah slanted him a look, and there was a glint in his eyes that said he understood. He shrugged and reached up, scraping at the stubble that darkened his face. “I’m pretty good with a hammer and nails. I’ll grab a few rolls of duct tape. Duct tape is always good.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They both laughed. It felt good to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They hadn’t done enough of it the past few weeks, and that was a fact.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There wasn’t going to be a whole lot of laughing in the near future, either. Not for Adam, not for Noah. Hell, most people in town had taken this like a punch to the face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Every time Adam closed his eyes, he saw that fire. He closed his eyes and he remembered a chat between a couple of kids.… That fire had "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("led")]), _vm._v(" to this. It could have been so much worse. Noah could be dead. Trinity could be dead. That kid of hers—funnier than hell and whip smart—he could be left without a mother. Yeah, it could be worse. But this was still pretty bad.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The town is better off, I think,” Adam said abruptly, folding his arms. The wind kicked up off the river, blowing his hair back from his face. He needed to get it cut, and he probably would remember … in another month or so. For now, he had his hands full, running short staffed at the bar, covering some extra nights at the forum while Noah dealt with everything he needed to do for a shotgun wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As Noah looked over at him, Adam jerked his shoulder up, tried not to let Noah look at him too closely. “Yeah. How much just downright "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("messed-up shit")]), _vm._v(" has been tied to this house?” Adam lifted a hand and ticked the events off, one by one. “Frampton murders his wife, beats her to death with his own hands—that’s been what, fifty or sixty years? Old Max probably put himself almost in the poorhouse trying to keep this place up and nothing ever came of it. Turns out those sick fucks were using this as their playground while they hurt kids.” Rage boiled inside Adam, an ugly, nasty brew that made him want to hurt anything and everything. But he couldn’t. If he gave in to that fury, he was going to lose himself; he knew it. He had come too close to that edge before. He couldn’t go risk coming that close again. He might never come back. Hard to balance on that sort of precipice when there wasn’t much on this side to hold him steady. Once the red had cleared from his vision, he continued. “This is the place where something happened to Lana. To that kid David. Maybe even his folks. We don’t know. We’ll never know. Maybe it’s one of them that was found down under the floorboards, maybe not. Trinity moves in here and she has an absolutely "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("brilliant")]), _vm._v(" start to her new life here in Madison, right?” He ticked off another finger. He couldn’t quite wrap his mind around how awful it must have been, crashing through rotting floorboards and coming face-to-face with a dead body—the skeletal remains had been down there who knows how long.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Bile climbed up his throat as images tried to shove their way into his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lana … it’s Lana.… ")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No. Absolutely no,")]), _vm._v(" and he wouldn’t let himself think about it, either.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Forcing himself to go on, he said, “Then, after "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("all of that,")]), _vm._v(" two kids nearly get themselves "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("and")]), _vm._v(" you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("and")]), _vm._v(" Trinity killed. Yeah, the town is better off.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He kicked at the dirt. “We should tear it all down; that’s what we should do.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A caustic voice added, “Salt the earth?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam closed his eyes. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What the hell.")]), _vm._v(" Sometimes he thought God was mocking him, throwing this guy in his path all the time. The man standing on the walk wore simple clothes—most of the Amish did. He had the typical ugly-ass haircut, although he hadn’t grown out the beard that a lot of the men from that lifestyle did. Might be because he wasn’t married. Adam thought the beard went with marriage but he wasn’t sure. Apparently none of the women could tolerate the bastard. Which just showed how smart the ladies were.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Caine Yoder was nothing but a grade A asshole.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As he joined them, Adam bared his teeth in a mockery of a smile. “Nice seeing you here, Caine. Hey, it’s Sunday. Don’t you have church or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From under the brim of his hat Caine studied Adam for a long minute. Then Caine looked at Noah and nodded. “I wanted to talk to you, see if they ever told you what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What happened?” Noah rubbed a thumb down his cheek. “Well. I was upstairs…” He pointed in the general direction. “And two kids outside decided to try and torch the place. They didn’t know we were inside. That pretty much sums it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Does anybody know why?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam snorted and then turned, reaching in through the open window of his car. The car was his baby, the one and only thing he took pride in, a classic rebuilt ’68 Corvette that had belonged to his dad. Adam had had to finish the restoration himself after his dad’s death and it had taken him three years to even be able to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("do")]), _vm._v(" it, but it was done now and the car was his.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The morning paper was in the backseat. Grabbing it, he shoved it toward Caine and then went back to staring at the house. “If you folks would actually "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("read")]), _vm._v(" shit from time to time, you might know why, Caine,” Adam said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, we read.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam slid Caine a narrow look. Caine gave him a patient, polite smile, but his eyes seemed to say, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fuck off")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah? What have you ever read besides your Bible?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well.” Caine took his time, acting like he was thinking it over. “I like picture books. The ones with the really bright pictures and the cute little kids. And sometimes, I like mysteries. There’s this one … with a bunny. All the vegetables in the house are mysteriously turning white. You ever read that one?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam had been the butt of more than a few jokes in his life. He had no doubt it was happening again, but he had no idea just what Caine’s game was. Adam opened his mouth to fire something back at Caine, but before he could Noah stepped between them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Enough.” Then Noah nodded toward Caine. “Caine. Not sure what game you’re playing, but Adam’s head isn’t a good one to screw with … he barely knows what "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("he")]), _vm._v(" is doing half the time. There’s no way he can explain anybody else’s rationale, and you’re not going to find the answers in the paper anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Caine rolled up the paper and held it back out to Adam, all without looking at him. His gaze stayed locked on Noah. “How is Caleb?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Caleb…” Noah drew it out and then he blew out a breath. “Caleb is a mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They aren’t going to put him back with his family, are they?” Caine asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No.” Then Noah sighed. “And beyond that, I don’t know anything more I can tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yeah, he did, Adam suspected.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But what Noah "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("knew")]), _vm._v(" and what Noah could "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("say")]), _vm._v(" were two different things.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adam understood that feeling. There were things he knew … and couldn’t say.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But he sure as hell would like to know just what secrets Noah harbored about that hellhouse. “Tear it down,” Adam murmured. “It’s not a bad plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think it’s a fine plan,” Caine said, his voice quiet. “I would even find the salt.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Noah looked at him, and then they both glanced at Caine. But that man was already moving off, in the direction of the ruined house.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You people.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It made him something of a hypocrite, Caine decided as he parked the truck. He could hear singing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It had been years since he’d attended church with his family.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It got his back up, though, having a prick like Adam Brascum taking digs at the Yoders, or people like them, based on what he thought he knew. It was those digs, more than anything else, that had Caine here.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There were close to two dozen buggies gathered around the small, simple building. He had missed much of the service and he didn’t really care. For some reason, he wanted to see Abraham.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Maybe it was a need to be in the man’s calming, restful presence.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There had been "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("nothing")]), _vm._v(" calming or restful in Caine’s life for a good long while now, and the past few weeks it had been worse.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It wasn’t even the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Or what had happened after.… ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His lids drooped as he moved through the bodies and settled at Abraham’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What happened after.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You don’t belong here,")]), _vm._v(" a scathing voice said in the back of his mind. He ignored it and focused on the voices, on the familiarity and the peace of them. He wouldn’t find God here, but he did find peace.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("“You were late,” Sarah Yoder said hours later, putting the plate of chicken down in front of him with more force than necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He nodded and waited until Abraham had served himself before he filled his plate. “I’m sorry, Sarah.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sarah was three years older than him. She looked like she had him by a decade, though. It wasn’t the simple dress the Amish wore, and it wasn’t the way she scraped her hair back from her face. It wasn’t even the plainness of her features. When she’d been younger she’d been kind of pretty, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But Sarah scowled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A lot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She glared at people; she snarled. She never laughed and she preferred to accuse or threaten rather than ask or request.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All that bitterness weighed on her, and not in a nice way.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He had a mouth full of mashed potatoes when she said, “You need to leave Madison and come back home. It’s an evil town, all the things happening back there. If you keep working there, being around those people, you’ll be as evil as they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sarah,” Abraham said quietly, catching his daughter’s eye. “That’s enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A mutinous look crossed her face. “You know what has taken place there. It’s vile.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s enough,” Abraham said, shaking his head. “I won’t hear another word on it. I spend little time with Caine as it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A tense moment of silence passed and then Sarah left the room, thankfully taking some of the tension with her. As the back door slammed shut, Caine rubbed the back of his neck. “I didn’t mean to ruin the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You didn’t.” Abraham smiled, his worn, tired face softening. “I think Sarah is the unhappy one today, not you.” The old man leaned back in his chair, his expression thoughtful. “You aren’t particularly happy yourself, Caine. What troubles you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sourly Caine laughed. “Life?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He tore a chunk of meat from the chicken breast and popped into his mouth, chewed it without really tasting it as he stared outside. “I find myself wanting to do bad things lately,” he murmured. He could trust Abraham. Caine’s words would go no further, and the other man wouldn’t judge him, either.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The police are involved,” Abraham murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Caine shifted his gaze to Abraham and then shook his head. “Is it enough? Will they "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("believe")]), _vm._v(" those boys?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You do.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Caine nodded. “Yes. I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then he sighed and tossed the rest of the meat down on the plate. His appetite fading, he wiped his hands on a simple white napkin and leaned back in the chair. “Even if they arrest all the men involved, what good does it do? It doesn’t undo the damage, does it? It goes too deep, goes back too far.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes. But there is nothing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("you")]), _vm._v(" can do, either. Let God sort it out, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Caine shot him a look.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was respect more than anything else that made Caine keep his mouth shut. But he’d stopped believing in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God")]), _vm._v(" a long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1-NOSPACE"
  }, [_vm._v("It was the second time in the span of just a couple of months that they had to dig a vehicle out of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That was pretty unusual even for a big city.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Madison, Indiana, was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" a big city.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What was even more fucked up was the fact that this vehicle, just like the first one, had a body inside it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This body, though, wasn’t old.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Charlie Junior had been missing only a few weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The last time he’d been seen was the morning he clocked out just after the big fire at the Frampton house.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His wife was currently on the bank of the river, half-drunk and clutching at her mother while they continued to work on the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was tricky business pulling a vehicle from a body of water.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Chief Sorenson had his way, Missy Sutter would be removed from the area, and if she started screaming again she "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("would")]), _vm._v(" be removed, whether she liked it or not. Damn the idiot who’d called her anyway. That was the problem with living in a town like Madison. Somebody had reported the truck and the call went out on the radio. Somebody had heard and given Missy a call—she’d gotten down here only a few minutes after the chief.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He didn’t want to think about what might have happened if she’d gotten here "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("before.")]), _vm._v(" She might have waded into the river herself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As it was, she had done nothing but yell at them to hurry, to help Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She didn’t understand her husband was past that kind of help.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Once she saw him … yeah. She was going to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sorenson knew what he was seeing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Charlie was still behind the wheel of the truck. The fish had been having their way with him, although that wasn’t going to keep the medical examiner from finding out just what had put Charlie in the river.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sorenson suspected there were no natural means involved. Charlie had been the fit sort. He didn’t think Charlie had a heart attack, and the truck wasn’t too messed up, so he didn’t think there was a wreck involved, either. Nor did he think Charlie had decided to up and kill himself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Sorenson had to make a call, right then and there, he’d go with his gut and say somebody had helped Charlie find his way into the river.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Not that he’d make a judgment call like that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Smart cops didn’t do that sort of thing. He’d just say … "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("suspicious death,")]), _vm._v(" because of course it was suspicious, seeing as how trucks don’t naturally find themselves in the water like that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Behind him, Missy started to shriek.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sorenson lifted his eyes to the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Please, Lord. Just give me patience.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He felt for the poor woman; he surely did.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But he’d tried to get her to leave. And she’d insisted she had a right to be here.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Now she was going to live with this image in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("“I shoulda listened.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Missy moaned it again, for the fifth time, over a cup of coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The cops around her had taken the little flask she’d tucked inside her purse. She’d tried to pop Jensen Bell for doing it, insisting it was just a medicinal tea she used to steady her nerves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jensen had rolled her eyes while pouring the vodka out. “Medicinal tea … I’ve heard it all now,” she’d muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Missy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Missy looked up, her eyes dull as she stared at Jensen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Can you help us here?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I want Charlie,” she whispered. “I want my Junior.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I know,” Jensen said, nodding. “I know. But we need you to help us help him now. Who could have done this?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nobody.” Missy reached for coffee and lifted it, her hands shaking. “Everybody loved him. He never hurt anybody and everybody loved him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Over Missy’s bent head, Sorenson met Jensen’s eyes and then nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If Jensen had any reservations at all, she never showed it. “Are you sure about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Missy lifted her head. “What do you mean by that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We have his name down as one of the participants in the Cronus Club.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Missy’s face went white, then red. “I don’t know what in the fuck that means.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Oh, yes, you do,")]), _vm._v(" Jensen thought, seeing the denial, the disgust, the confusion, all the emotion Missy tried to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s a club, a boys’ club of sorts … where the men meet up every month or so … and they rape their sons, trading them back and forth,” Jensen said, pasting a vague smile on her face as she said it. Like she was discussing the weather or what she might wear to Shakers that night. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yeah … this is just a thing here. Let’s talk about it.… ")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She saw Missy’s hand and moved just in time.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The scalding coffee would have felt really nice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You crazy bitch!” Missy screeched. “You fucking "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("evil")]), _vm._v(" bitch! My Charlie didn’t do that. And those boys are just a bunch of fucking "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("liars")]), _vm._v("! If they say anybody "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("raped")]), _vm._v(" them, they are wrong!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 81
// module chunks = 0